<template>
  <div class="container-pay" :style="`paddingTop:${barHeight}px`">
    <van-nav-bar class="van-bar" :title="$t('lang.pay.store')" left-arrow @click-left="goBack">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" />
      </template>
    </van-nav-bar>

    <div class="main">
      <div class="pay">
        <div class="money-block">
          <img class="moneys" :src="getMatchImg('coins')" alt="" />
          <div>{{ amount }}</div>
          <i v-if="presentAmount > 0">+{{ presentAmount }}</i>
        </div>
        <div class="pay-other">
          <template v-for="(item, index) in presentPropList">
            <div v-if="item.propType == 1" class="dis-item">
              <img :src="getMatchImg('chat-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 2" class="dis-item">
              <img :src="getMatchImg('video-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 4" class="dis-item">
              <img :src="getMatchImg('vip')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 6" class="dis-item">
              <img :src="getMatchImg('call-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 9" class="dis-item">
              <img :src="getMatchImg('coupon')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 15" class="dis-item">
              <img :src="getMatchImg('super-chat-pass')" />
              x{{ item.number }}
            </div>
          </template>
        </div>
      </div>

      <div class="select-tit">{{ $t('lang.wd.methodTit') }}</div>
      <!-- 优惠卷入口 -->
      <CouponEnter v-if="scene != 'activity'" @openCouponPop="openCouponPop" :maxCoupon="maxCoupon" :styleType="'for-vava'"></CouponEnter>
      <div
        v-for="(item, index) in payList"
        :key="index"
        :class="['method-item', loadingAn ? loadingAnimation : '', disClassFn(item.desc, packageName)]"
        @click="handleClickPay(item, index)"
      >
        <MyPLabel class="discount" v-if="item.desc" :str="item.desc" :customClass="{ coin: 'discount-coins' }" />
        <div class="method-con" :class="{ noClick: loadingShow }">
          <template v-if="showGoogle">
            <div class="method-img"><img :src="item.icon | imgPath" alt="" /></div>
            <div class="line"></div>
            <div class="method-name" v-if="item.icon">
              <span>{{ item.name }}</span>
              <div class="rate">
                <div class="pay-price-btn" :style="{ width: longestWidth + 'px' }">
                  <span :class="{ actTextColor: loadingShow && item.name == selectPayName }">
                    <i>{{ item.currency }}</i>
                    {{ handleDiv100(item.price) }}
                  </span>
                  <van-loading v-if="loadingShow && item.name == selectPayName" type="spinner" color="#ffffff" class="pay-loading" size="20px" />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="methods-tip arBefore" v-if="showGoogle && tip">
        {{ tip }}
      </div>

      <!-- Google Pay -->
      <GooglePay
        :longestWidth="longestWidth"
        :googlePriceOld="googlePriceOld"
        :googlePrice="googlePrice"
        :currency="googlePriceCurrency"
        :loadingShow="loadingShow"
        @googlePay="googlePay"
      />
    </div>

    <CouponPopup
      :active="popActive"
      :showCouponPopup="showCoupon"
      :tebTit="tebTit"
      @close="closePop"
      :maxCoupon="maxCoupon"
      :validCouponListSort="validCouponListSort"
      :expiredCouponList="expiredCouponList"
      :styleType="`for-${packageName}`"
      @confirmChooseCouponId="confirmChooseCouponId"
    />

    <!-- 支付结果弹窗 -->
    <PayResult :showDiaC="showResultDia" :oneShow="true" :title="payResultText" />
  </div>
</template>

<script>
// 收营台
import { apiFetchPayList, apiFetchShopOrder } from '@/api/imee'
import { mixin } from '@/mixin/index.js'

import CCouponEnter from '@/components/CCouponEnter'
import CCoupon from '@/components/CCoupon'
import GooglePay from './component/GooglePay.vue'
import PayResult from '@/components/CConfirm/PayResult.vue'
import _debounce from 'lodash/debounce'

export default {
  mixins: [mixin],
  components: {
    CouponEnter: CCouponEnter,
    CouponPopup: CCoupon,
    GooglePay,
    PayResult
  },
  data() {
    let query = this.$route.query
    return {
      // 兼容以前的  googlePriceOld 现在货币和价格分开返回
      googlePriceOld: query.googlePrice || null,
      googlePrice: query.price || null,
      googlePriceCurrency: query.currency || null,
      barHeight: query.statusBarHeight || 38,
      payList: [],
      amount: 0,
      gid: query.gid || '1',
      productId: null,
      thirdParam: query.thirdParam || null,
      lowPrice: '',
      loadingShow: false,
      showGoogle: false,
      loadingAn: true,
      // pix的数据
      pixData: null,
      tip: query.tip || '',

      loadingFlag: false,
      selectPayName: null,
      // 支付方式统计
      selectChannelIndex: -1,
      // 优惠信息
      presentAmount: 0,
      presentPropList: []
    }
  },
  watch: {
    validCouponList: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fatchMaxCoupon({ amount: this.amount }, newVal)
        }
      }
    }
  },
  methods: {
    disClassFn(desc, packageName) {
      if (desc) {
        let className = ''
        switch (packageName) {
          case 'vava':
            className = 'has-dis-green'
            break
          case 'echo':
          case 'joychat':
            className = 'has-dis-lightgreen'
            break
          default:
            className = 'has-dis-green'
        }
        return className
      }
      return ''
    },
    // 刷新
    refresh() {
      // 获取有效优惠劵
      this.fetchCouponList(0)
    },

    fetchPayList() {
      const resolvePayList = (res) => {
        this.loadingAn = false
        this.productId = res.productId
        this.amount = res.amount || 0
        this.presentAmount = res.presentAmount || 0
        this.presentPropList = res.presentPropListV2 || []

        // this.amount = res.amount || 10
        // this.presentAmount = res.presentAmount || 13
        // this.presentPropList = res.presentPropListV2 || [
        //   { propType: 0, number: 23 },
        //   { propType: 1, number: 23 },
        //   { propType: 2, number: 23 },
        //   { propType: 4, number: 23 },
        //   { propType: 6, number: 23 },
        //   { propType: 9, number: 23 },
        //   { propType: 15, number: 23 }
        // ]

        this.payList = res.payChannelList || []
        this.processData(res.payChannelList)
        this.loadingShow = false
        this.showGoogle = true

        // 获取最小值
        this.lowPrice = Math.min.apply(
          Math,
          this.payList.map(function (item) {
            return item.price
          })
        )
      }

      this.loadingShow = true
      this.showGoogle = false
      this.loadingAn = true

      // 读取web localstorage缓存
      const localRes = window.localStorage.getItem(`payList${this.gid}`)
      if (localRes) {
        resolvePayList(JSON.parse(localRes))
      }

      apiFetchPayList({
        gid: this.gid,
        activityType: this.$route.query.activityType,
        shopType: this.scene == 'activity' ? 7 : null
      }).then((res) => {
        if (res && res.payChannelList) {
          // 写入web localstorage缓存
          window.localStorage.setItem(`payList${this.gid}`, JSON.stringify(res))

          resolvePayList(res)
        }
      })
    },

    handleClickPay(item, index) {
      this.selectChannelIndex = index
      this.handlePay(item)
    },

    handlePay: _debounce(
      function (item) {
        let payChannelTotal = null
        if (this.payList && this.payList.length) {
          payChannelTotal = this.payList.length
        }
        let payChannelIndex = null
        if (this.selectChannelIndex != -1 && payChannelTotal !== null && payChannelTotal !== 0) {
          payChannelIndex = payChannelTotal - 1 - this.selectChannelIndex
        }
        if (this.googlePrice && this.googlePriceCurrency && payChannelTotal !== null && payChannelIndex !== null) {
          payChannelTotal = payChannelTotal + 1
          payChannelIndex = payChannelIndex + 1
        }

        let data = {
          tierId: this.$route.query.tierId || null,
          shopType: this.$route.query.shopType || null,
          gid: this.gid,
          payType: item.payType,
          scene: this.scene,
          thirdParam: this.thirdParam,
          payChannel: item.name,
          payChannelIndex: payChannelIndex,
          payChannelTotal: payChannelTotal
        }
        if (this.$route.query.videoChatScene) {
          data.videoChatScene = this.$route.query.videoChatScene
        }
        if (this.$route.query.activityType) {
          data.activityType = this.$route.query.activityType
        }
        if (this.maxCoupon && this.scene != 'activity') {
          data.couponRecordId = this.maxCoupon.couponRecordId
        }
        if (this.scene == 'activity') {
          data.shopType = 7
        }
        this.$client.addEvent('top_up', { Action: 'Click', APosition: 'payButton', productID: this.productId, goodtype: 'coin', from: 'cash', paymethod: item.name })
        this.selectPayName = item.name
        this.loadingShow = true

        apiFetchShopOrder(data)
          .then((res) => {
            // 获取有效优惠劵
            this.fetchCouponList(0)
            if (res) {
              this.order = res.credential && res.credential.wapUrl
              // 外部浏览器打开
              if (res.credential.openInExternalBrowser) {
                let url = 'iMee://open_web_outside?url=' + res.credential.wapUrl
                commandRouter.postMessage(url)
                if (['10', '18', '19'].includes(this.$route.query.activityType)) {
                  this.closeWeb()
                }
              }
              // webview打开
              else {
                if (this.order) {
                  this.$router.push({
                    path: '/pay-code',
                    query: {
                      url: this.order
                    }
                  })
                }
              }
            }
          })
          .catch(() => {})
          .finally(() => {
            this.loadingShow = false
          })
      },
      2000,
      {
        leading: true,
        trailing: false
      }
    ),

    // 调谷歌的时候需要客户端提供方法
    googlePay() {
      // payGoogleFromWeb
      // 从 h5 活动页进入，客户端不知道商品信息，不知道优惠券信息
      if (this.$route.query.useWebPay == '1') {
        let params = {
          gid: this.gid,
          productId: this.$route.query.productId,
          activityType: this.$route.query.activityType * 1,
          scene: this.$route.query.scene || '',
          tierId: this.$route.query.tierId || null,
          shopType: this.$route.query.shopType || null
        }
        // 使用优惠券
        if (this.maxCoupon) {
          params.couponRecordId = this.maxCoupon.couponRecordId
        }
        payGoogleFromWeb.postMessage(JSON.stringify(params))
        // 调用支付后 关闭支付页面
        if (['10', '18', '19'].includes(this.$route.query.activityType)) {
          this.closeWeb()
        }
      }
      // payGoogle
      // 从客户端商品列表进入，客户端知道商品信息，不知道优惠券信息
      else {
        let params = {
          tierId: this.$route.query.tierId || null,
          shopType: this.$route.query.shopType || null
        }
        if (this.maxCoupon) {
          params.couponRecordId = this.maxCoupon.couponRecordId
        }
        payGoogle.postMessage(JSON.stringify(params))
      }
    },

    // 关闭结果弹窗
    cancelAgain() {
      this.showResultDia = false
    },

    // 从客户端获取googlePay/applePay参数
    queryGoogleProductListCallback(res) {
      if (res) {
        try {
          const googlePayList = JSON.parse(res)
          const targetItem = googlePayList.find((item) => {
            return this.$route.query.productId == item.productId
          })
          if (targetItem) {
            this.googlePriceOld = ''
            this.googlePrice = targetItem.price
            this.googlePriceCurrency = targetItem.currencyCode
          }
        } catch (err) {
          console.log('try catch err:', err)
        }
      }
    }
  },
  created() {
    this.fetchPayList()

    window.refresh = this.refresh

    // 从客户端获取googlePay/applePay参数
    window.queryGoogleProductListCallback = this.queryGoogleProductListCallback
  },
  mounted() {
    // 从客户端获取googlePay/applePay参数
    this.$route.query.productId && this.$client.googleProductList([this.$route.query.productId])
  }
}
</script>
<style lang="scss" scoped>
.container-pay {
  width: 100%;
  background: #fff;
  .main {
    padding: 0 18px 20px;
  }
  .pay {
    width: 100%;
    margin: 50px 0;
    .money-block {
      display: flex;
      align-items: center;
      justify-content: center;

      color: #222222;
      font-family: Lato;
      font-size: 28px;
      font-weight: 700;
      .moneys {
        width: 45px;
        height: 45px;
      }
      div {
        padding: 0 4px 0 12px;
      }
      i {
        color: #f95151;
      }
    }
    .pay-other {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 16px;
      .dis-item {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        color: #333333;
        font-family: Lato;
        font-size: 14px;
        font-weight: 700;
        line-height: 22px;
        img {
          width: 25px;
        }
      }
    }
  }
  .cpf-input {
    margin-bottom: 18px;
    margin-bottom: 10px;
    display: block;
    font-size: 17px;
    font-family: Inter-SemiBold;
    font-weight: 500;
    color: #333333;
    .tit {
      display: block;
      font-size: 16px;
      color: #000;
      margin-bottom: 10px;
    }
    .input {
      width: 100%;
      height: 50px;
      padding: 0 10px;
      border-radius: 10px;
      border: 1px solid #ccc;
      &::placeholder {
        color: #b5b5b5 !important; /* 设置placeholder的文本颜色 */
        font-size: 14px !important; /* 设置placeholder的文本大小 */
      }
    }
  }
  .select-tit {
    margin-bottom: 20px;
    font-size: 17px;
    font-family: Inter-SemiBold, Inter;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
  }

  .method-item {
    width: 100%;
    margin-bottom: 20px;
    border-radius: 10px;

    .discount {
      padding: 4px 10px;
      font-family: Outfit;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      text-align: center;
      color: #ffffff;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }

    .method-con {
      display: flex;
      align-items: center;
      width: 100%;
      height: 56px;
      padding: 0 8px;
      background: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.08);
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;

      .method-img {
        display: flex;
        justify-content: center;
        > img {
          width: 54px;
          height: 32px;
          object-fit: contain;
        }
      }
      .line {
        height: 20px;
        margin: 0 5px;
        border-right: 1px solid #d8d8d8;
      }
      .method-name {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        font-family: Inter;
        font-weight: 600;
        font-size: 14px;
        color: #333333;

        .rate {
          display: flex;
          align-items: center;
          .pay-price-btn {
            position: relative;
            padding: 8px 5px;
            background: #424145;
            border-radius: 6px;
            font-family: Inter-Regular;
            font-weight: 600;
            font-size: 15px;
            color: #ffd786;
            text-align: center;
            i {
              font-size: 8px;
            }
          }
          .pay-loading {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .actTextColor {
            opacity: 0.1;
          }
          // .img-desc {
          //   position: relative;
          //   width: 32px;
          //   height: 32px;
          //   margin-right: 4px;
          //   display: flex;
          //   align-items: center;
          //   > img {
          //     width: 100%;
          //     height: 100%;
          //   }
          //   .img-desc-text {
          //     font-family: Inter-Regular;
          //     font-size: 11px;
          //     color: #fff600;
          //     width: 100%;
          //     height: 100%;
          //     padding-bottom: 4px;
          //     position: absolute;
          //     display: flex;
          //     flex-direction: column;
          //     align-items: center;
          //     justify-content: center;

          //     > span {
          //       line-height: 13px;
          //     }
          //     > span:nth-child(2) {
          //       font-family: Inter-Regular;
          //       font-size: 8px;
          //       line-height: 9px;
          //     }
          //   }
          // }
        }
      }
    }
  }

  .has-dis-green {
    border: 1px solid #4caf50;
    .discount {
      background: #4caf50;
    }
  }

  .has-dis-lightgreen {
    border: 1px solid #2dcd90;
    .discount {
      background: #2dcd90;
    }
  }

  .noClick {
    pointer-events: none;
    filter: grayscale(100%);
  }

  .methods-tip {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    margin: 20px 0;
    padding: 14px 20px;
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    background: linear-gradient(90deg, #d2adfc 0%, #f4b4ed 100%);
    border-radius: 10px;
  }
  .methods-tip::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 30px;
    display: inline-block;
    width: 26px;
    height: 12px;
    margin-right: 8px;
    border-radius: 50%;
    background: url('~@/assets/packageAssets/views/P1_Boys/Pay/vava/up_icon.png') no-repeat;
    background-size: 100% 100%;
  }

  .loadingAnimation {
    animation: fadeInOut 1.2s infinite;
  }
  .tip {
    width: 100%;
    padding: 0 16px;
    margin-top: 25px;
    font-family: Inter;
    font-weight: 500;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    > i {
      color: #ff0000;
    }
  }

  @keyframes fadeInOut {
    0% {
      opacity: 1;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
    }
  }
}
::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: Inter-Bold, Inter;
  font-weight: bold;
  color: #333333;
}
::v-deep .coupon-enter {
  margin-bottom: 20px;
}
</style>

<style>
.discount-coins {
  width: 14px;
  height: 14px;
}
</style>
